import React, { useState, useEffect } from 'react';
import './ApplePay.css';
import { useStore } from 'Hooks/useStore';
import { isApplePayAvailable } from 'Api/ApplePay';
import { SubmitButton } from 'Components/Fields/Buttons';

export const ApplePayButton = ({ onClick, submitButtonText }) => {
  const [isApplePaySupported, setCanApplePay] = useState(false);
  const paymentMethods = useStore('paymentMethods');
  const subscription = useStore('subscription');

  useEffect(() => {
    let { deviceEnabled, isAvailable } = isApplePayAvailable();
    if (paymentMethods.isSuccess) {
      if (subscription.isChurnedRestartAvailable) {
        isAvailable = false;
      }
    }
    setCanApplePay(deviceEnabled && isAvailable);
  }, [paymentMethods, subscription]);

  return (
    <ApplePayButtonView
      isApplePaySupported={isApplePaySupported}
      onClick={onClick}
      submitButtonText={submitButtonText}
    />
  );
};

export const ApplePayButtonView = ({ onClick, submitButtonText, isApplePaySupported }) => {
  return (
    <div className="applePayButtonContainer">
      <SubmitButton isDisabled={!isApplePaySupported} text={submitButtonText} onClick={onClick} modernLayout />
    </div>
  );
};
